export class Endereco {
  cep: string = '';
  logradouro: string = '';
  numero: string = '';
  complemento: string = '';
  cidade: string = '';
  bairro: string = '';
  uf: string = '';
}
